type JobWithDates = {
  dates: {
    start_recalculated: number;
    end_recalculated?: number;
  };
};

/**
 * "Sorts jobs by putting current jobs (without an end date) first,
 * ordered by start date, followed by ended jobs,
 * ordered by end date."
 *
 * @param jobs - Array of job objects with dates to sort
 * @returns Sorted array with ended jobs first, current jobs last
 */
export const sortJobsByDates = <T extends JobWithDates>(jobs: T[]): T[] => {
  const currentJobs = jobs.filter((job) => !job.dates.end_recalculated);
  const endedJobs = jobs.filter((job) => job.dates.end_recalculated);

  const sortedCurrentJobs = currentJobs.sort((a, b) => b.dates.start_recalculated - a.dates.start_recalculated);

  const sortedEndedJobs = endedJobs.sort((a, b) => {
    const endDiff = (b.dates.end_recalculated ?? 0) - (a.dates.end_recalculated ?? 0);
    if (endDiff !== 0) return endDiff;
    return b.dates.start_recalculated - a.dates.start_recalculated;
  });

  return [...sortedCurrentJobs, ...sortedEndedJobs];
};
